export class SubscriptionGroupModel {
  public insert;
  public remove;
}
